
import InlineCalendar from 'vux/src/components/inline-calendar/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'

import dateFormat from 'vux/src/tools/date/format.js'

export default {
filters: {
dateFormat
},
components: {
InlineCalendar,
XHeader,
Timeline,TimelineItem
},
data() {
return {
title: "签到打卡",
buildSlotFn: (line, index, data) => {
return this.isMatched(data) ?
'<div style="font-size:12px;text-align:center;"><span style="display:inline-block;width:15px;height:15px;background-color:#60C9FE;border-radius:50%;"></span><span class="calendar-signed"></span></div>' :
'<div style="height:19px;"></div>'
},
todos: [],
todo: {},
signin_days1:"0",
signin_days2:"0",
signin_days3:"0",
signin_days4:"0",
datelist:[],
user:{},
userid:"",
username:"",
d:0,
c:0,
uxuebi:0
}
},
mounted() {
},
created: function () {
},
beforeMount:function(){




























},
methods: {
initdata: function () {
let that = this;
that.$vux.loading.show({
text: '加载中...'
});
var url = $.serverInfo.server + "signin/tj";
var params = new URLSearchParams();
params.append('userid', that.userid);
params.append('username', that.username);
this.$http.post(url, params).then(response => {
setTimeout(() => {
var ny1 = response.data.ny1;
var ny2 = response.data.ny2;
that.datelist = eval(response.data.datelist);
var nylist = response.data.nylist;
var days = response.data.days;
that.signin_days1 = response.data.days1;
that.signin_days2 = response.data.days2;
that.signin_days3 = response.data.days3;
that.signin_days4 = response.data.days4;
that.todos = eval(nylist);

let params2 = new URLSearchParams();
params2.append('id', that.userid);
that.$http.post($.serverInfo.server + 'api/mobileuser/getUserByUid',params2).then(response => {
let user = response.data;
that.uxuebi = user.uxuebi;
}, response => {
that.$vux.loading.hide();

});

that.$vux.loading.hide(); 
})
}, response => {

that.$vux.loading.hide(); 
});
},
share_info: function () {
let that = this;
that.$vux.loading.show({
text: '加载中...'
});
var url = $.serverInfo.server + "signin/dkfx";
var params = new URLSearchParams();
params.append('userid', that.userid);
that.$http.post(url, params).then(response => {
setTimeout(() => {
var info = response.data.info;
var date = dateFormat(new Date(), 'YYYY-MM-DD');
$.webdb.selectWithCondition(window.education, 'T_SHARETIME', 'where datestring=\''+ date+'\'',function(results) {
if(results.rows.length <= 3){
var result = cordova.plugins.UpdatePlugin.share(that.userid,"circle","","",$.serverInfo.server+"share/invite?u="+that.userid+"&d="+that.d+"&c="+that.c,function(e){

that.fxxb(that.userid);
$.webdb.executeSql(window.education, 'insert into T_SHARETIME(datestring) values(\'' + date + '\')');
},function(){
that.$vux.toast.show({
type: 'text',
position: 'center',
text: '分享失败。'
});
});
}else{
that.$vux.toast.show({
type: 'text',
position: 'center',
text: '您今天的分享次数已经用完，请明天再来。'
});
}
});
that.$vux.loading.hide(); 
})
}, response => {

that.$vux.loading.hide(); 
});
},
isMatched: function (data) {
return this.datelist.indexOf(data.formatedDate)!=-1;
},
fxxb : function(userid) {
let that = this;



var url = $.serverInfo.server + "signin/fxxb";
var params = new URLSearchParams();
params.append('userid', userid);
that.$http.post(url, params).then(response => {
setTimeout(() => {
var result = response.data.result;
var xbz = response.data.xbz;

if(result == true || result == "true") {

that.$vux.toast.show({
type: 'text',
position: 'center',
text: '分享成功获得'+xbz+'学币.'
});

let params2 = new URLSearchParams();
params2.append('id', that.userid);
that.$http.post($.serverInfo.server + 'api/mobileuser/getUserByUid',params2).then(response => {
let user = response.data;
that.uxuebi = user.uxuebi;
}, response => {
that.$vux.loading.hide();

});
}

})
}, response => {


});
}
}
}




// WEBPACK FOOTER //
// ./src/views/clockIn/clockIn.vue